export default __webpack_public_path__ + "static/media/shoe.dfc79bb7.gif";